import { Button, colors, Modal, ModalActions, ModalHeader, Typography } from '@ui-components/neo.tax';
import { ReactComponent as AlarmBellRing } from '@ui-components/neo.tax/dist/icons/alarm-bell-ring.svg';

import { evictCache } from '@neo.tax/shared';

import { useLinkTicketingProviderUserToRdTaxCreditContributor } from './hooks';

type LinkTicketingProviderUserToPayrollExpenseModalProps = {
  isOpen: boolean;
  onClose: () => void;
  rdTaxCreditContributorId: string;
  ticketingProviderUserId: string;
};

export const LinkTicketingProviderUserToRdTaxCreditContributorModal = ({
  isOpen,
  onClose,
  rdTaxCreditContributorId,
  ticketingProviderUserId,
}: LinkTicketingProviderUserToPayrollExpenseModalProps): React.ReactElement => {
  const [linkTicketingProviderUserToRdTaxCreditContributor, { loading }] =
    useLinkTicketingProviderUserToRdTaxCreditContributor();
  const handleCancel = (): void => {
    onClose();
  };

  const handleConfirm = async (): Promise<void> => {
    await linkTicketingProviderUserToRdTaxCreditContributor({
      variables: {
        rdTaxCreditContributorId,
        ticketingProviderUserId,
      },
      awaitRefetchQueries: true,
      refetchQueries: ['GetPayrollQres', 'GetTicketingUsers'],
      update: (cache) => {
        evictCache(cache, ['getPayrollExpense']);
      },
    });
    onClose();
  };

  return (
    <Modal isOpen={isOpen}>
      <ModalHeader
        icon={<AlarmBellRing width={24} color={colors.blue[600]} />}
        iconBgColor={colors.blue[50]}
        title={
          <Typography fontSize="base" fontWeight="semibold">
            Link New Account?
          </Typography>
        }
      />
      <ModalActions hasTopBorder={false}>
        <Button disabled={loading} variant="white" rounded="regular" size="base" onClick={handleCancel}>
          Cancel
        </Button>
        <Button disabled={loading} variant="primary" rounded="regular" size="base" onClick={handleConfirm}>
          Save
        </Button>
      </ModalActions>
    </Modal>
  );
};
